import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Glyphicon } from 'react-bootstrap';
import classnames from 'classnames';

import { LoadingSpinner } from '../../../components/LoadingSpinner';

import './styles/Comment.css';

const Comment = ({
  content,
  date,
  image,
  isLoading,
  likesCount,
  onImageLoad,
  showReplies,
  repliesCount,
  showShares,
  sharesCount,
  style
}) => {
  const markup = isLoading ? (
    <div className="tvt-comment-feed__loading-spinner">
      <LoadingSpinner />
    </div>
  ) : (
    <Fragment>
      <header className="tvt-comment-feed__comment-header">
        <div className="tvt-comment-feed__comment-info">
          <span className="tvt-comment-feed__comment-date">{date}</span>
        </div>
      </header>

      <div className="tvt-comment-feed__comment-content">
        {content && <p className="tvt-comment-feed__comment-text">{content}</p>}

        {image && (
          <p className="tvt-comment-feed__comment-image">
            <img src={image} alt={date} onLoad={onImageLoad} />
          </p>
        )}

        <p className="tvt-comment-feed__comment-likes">
          <Glyphicon glyph="heart-empty" />
          <span className="tvt-comment-feed__comment-count">{likesCount}</span>

          {showReplies && (
            <Fragment>
              <Glyphicon glyph="comment" />
              <span className="tvt-comment-feed__comment-count">
                {repliesCount}
              </span>
            </Fragment>
          )}

          {showShares && (
            <Fragment>
              <Glyphicon glyph="share-alt" />
              <span className="tvt-comment-feed__comment-count">
                {sharesCount}
              </span>
            </Fragment>
          )}
        </p>
      </div>
    </Fragment>
  );

  const className = classnames('tvt-comment-feed__comment', {
    'tvt-comment-feed__comment--loading': isLoading
  });

  return (
    <div className={className} style={style}>
      {markup}
    </div>
  );
};

Comment.propTypes = {
  content: PropTypes.string,
  date: PropTypes.string,
  image: PropTypes.string,
  isLoading: PropTypes.bool,
  likesCount: PropTypes.number,
  onImageLoad: PropTypes.func,
  repliesCount: PropTypes.number,
  showReplies: PropTypes.bool,
  sharesCount: PropTypes.number,
  showShares: PropTypes.bool,
  style: PropTypes.shape({}).isRequired
};

Comment.defaultProps = {
  content: '',
  date: '',
  image: '',
  isLoading: true,
  likesCount: 0,
  onImageLoad: () => {},
  showReplies: true,
  repliesCount: 0,
  showShares: false,
  sharesCount: 0
};

export default Comment;
